import AdminPage from '@/pages/admin';
import AdminSettingsPage from '@/pages/admin/settings';
import AdminStatsPage from '@/pages/admin/stats';
import AdminUserDetailPage from '@/pages/admin/users/detail';
import AdminUsersPage from '@/pages/admin/users';
import AuthPage from '@/pages/auth';
import BuilderPage from '@/pages/builder';
import ClientPage from '@/pages/client';
import ClientsPage from '@/pages/clients';
import MyClientPage from '@/pages/my-client';
import MyClientsPage from '@/pages/my-clients';
import ProfilePage from '@/pages/profile';
import ProtectedRoute from '@/components/protected-route';
import AppShell from '@/layouts/app-shell';
import { ROUTES } from '@/app/routes';
import { createRoot } from 'react-dom/client';
import { Navigate, createBrowserRouter, RouterProvider } from 'react-router';
import App from './App';
import './index.css';

export const router = createBrowserRouter([
	{
		path: '/',
		Component: App,
		children: [
			{
				path: ROUTES.auth,
				Component: AuthPage,
			},
			{
				Component: AppShell,
				children: [
					{
						path: ROUTES.myClients,
						Component: MyClientsPage,
					},
					{
						path: ROUTES.clients,
						Component: () => (
							<ProtectedRoute roles={['carder', 'admin']}>
								<ClientsPage />
							</ProtectedRoute>
						),
					},
					{
						path: ROUTES.builder,
						Component: BuilderPage,
					},
					{
						path: `${ROUTES.myClient}:id`,
						Component: MyClientPage,
					},
					{
						path: ROUTES.client + ':id',
						Component: () => (
							<ProtectedRoute roles={['carder', 'admin']}>
								<ClientPage />
							</ProtectedRoute>
						),
					},
					{
						path: ROUTES.admin,
						Component: () => (
							<ProtectedRoute roles={['admin']}>
								<AdminPage />
							</ProtectedRoute>
						),
					},
					{
						path: ROUTES.adminUsers,
						Component: () => (
							<ProtectedRoute roles={['admin']}>
								<AdminUsersPage />
							</ProtectedRoute>
						),
					},
					{
						path: `${ROUTES.adminUser}:profileId`,
						Component: () => (
							<ProtectedRoute roles={['admin']}>
								<AdminUserDetailPage />
							</ProtectedRoute>
						),
					},
					{
						path: ROUTES.adminStats,
						Component: () => (
							<ProtectedRoute roles={['admin']}>
								<AdminStatsPage />
							</ProtectedRoute>
						),
					},
					{
						path: ROUTES.adminSettings,
						Component: () => (
							<ProtectedRoute roles={['admin']}>
								<AdminSettingsPage />
							</ProtectedRoute>
						),
					},
					{
						path: ROUTES.profile,
						Component: ProfilePage,
					},
				],
			},
			{
				path: '/home',
				element: <Navigate to={ROUTES.profile} replace />,
			},
			{
				path: '/settings',
				element: <Navigate to={ROUTES.profile} replace />,
			},
			{
				index: true,
				element: <Navigate to={ROUTES.profile} replace />,
			},
		],
	},
]);

createRoot(document.getElementById('root')!).render(<RouterProvider router={router} />);
